import { Dimensions } from '../types/misc';

export class ImageFromDataState implements Dimensions {
  constructor(
    public width: number,
    public height: number,
    public data?: Uint8ClampedArray,
  ) {}
}

export function newDataForImage(imageSize: Dimensions) {
  return new Uint8ClampedArray(imageSize.width * imageSize.height * 4);
}

export function toImageData(imageLayer: ImageFromDataState) {
  if (!imageLayer.data) {
    throw new Error('cannot convert layer with no image data to ImageData');
  }
  return new ImageData(imageLayer.data, imageLayer.width, imageLayer.height);
}
